import * as React from "react"
import {renderRichText} from "gatsby-source-contentful/rich-text";
import ArticleImage from "../ArticleImage";
import TextImage from "../TextImage";

const BlocksContent = ({page}) => {
  let blocksContent = []

  page.references.forEach((reference, index) => {
    if (reference.__typename === "ContentfulContentBlock") {
      blocksContent.push(
        <div key={index}>
          {renderRichText(reference.content)}
        </div>
      )
    }

    if (reference.__typename === "ContentfulImageBlock") {
      blocksContent.push(
        <ArticleImage key={index} image={reference.image} loading={"lazy"} frame={reference.includeFrame} />
      )
    }

    if (reference.__typename === "ContentfulTextImageBlock") {
      blocksContent.push(
        <TextImage key={index} image={reference.image} content={reference.content} position={reference.imagePosition} />
      )
    }
  });

  return (
    <>
      {blocksContent}
    </>
  )
}

export default BlocksContent;
